import type { ConnectorType } from '@/types'

export const REPO_CONNECTOR_TYPES: ConnectorType[] = ['AzureDevOps', 'GitHub', 'GitLab', 'Bitbucket']
